// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__cpzS6","collapse":"styles_collapse__Xu4Jh","button":"styles_button__24jMa","heading":"styles_heading__ipBej"};